export default "__VITE_ASSET__CXZlRiqM__"